$(document).ready(function () {
    'use strict';

    $('.carTabHeader').on('click', function () {
        $(this).toggleClass('active').siblings('.carTabHeader').removeClass('active');
    });
});